import { setupApiClient } from "./api";

export const api = setupApiClient();
